import { buildPersonInitials } from '@autosign/utils'
import { useCallback } from 'react'
import { useSigning } from '../../Context'
import { useSigningForm } from '../Provider'
import { BindingField } from './BindingField'
import { SigningFormFieldProps } from './Switcher'

export const InitialsField = (props: SigningFormFieldProps) => {
  const form = useSigningForm()
  const signing = useSigning()

  const initials = form.watch(props.path)

  const handleClick = useCallback(() => {
    const initials = buildPersonInitials(signing.recipient.name!)

    form.setValue(props.path, initials)

    props.onPersist(initials)
  }, [])

  if (initials) {
    return (
      <div>
        <p className='font-bold'>{initials}</p>
      </div>
    )
  }

  return (
    <BindingField id={props.field.id} onClick={handleClick}>
      Iniciales
    </BindingField>
  )
}
